var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"k-time",class:_vm.skinName},[_vm._v(_vm._s(_vm.time2text(_vm.value, _vm.template)))])}
var staticRenderFns = []

export { render, staticRenderFns }